import React, { CSSProperties } from 'react';

interface IProps {
  className?: string;
  styles?: CSSProperties;
}

export const RedErrorIcon = ({ className, styles }: IProps) => {
  return (
    <svg
      style={styles}
      className={className}
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 8.86538C6.11442 8.86538 6.21033 8.82667 6.28775 8.74925C6.36517 8.67183 6.40387 8.57592 6.40387 8.4615C6.40387 8.34708 6.36517 8.25117 6.28775 8.17375C6.21033 8.09642 6.11442 8.05775 6 8.05775C5.88558 8.05775 5.78967 8.09642 5.71225 8.17375C5.63483 8.25117 5.59613 8.34708 5.59613 8.4615C5.59613 8.57592 5.63483 8.67183 5.71225 8.74925C5.78967 8.82667 5.88558 8.86538 6 8.86538ZM6.00013 7.0385C6.10646 7.0385 6.1955 7.00254 6.26725 6.93063C6.33908 6.85879 6.375 6.76975 6.375 6.6635V4.4135C6.375 4.30725 6.33904 4.21817 6.26713 4.14625C6.19521 4.07442 6.10612 4.0385 5.99988 4.0385C5.89354 4.0385 5.8045 4.07442 5.73275 4.14625C5.66092 4.21817 5.625 4.30725 5.625 4.4135V6.6635C5.625 6.76975 5.66096 6.85879 5.73288 6.93063C5.80479 7.00254 5.89388 7.0385 6.00013 7.0385ZM6.00087 11.25C5.34387 11.25 4.72633 11.1253 4.14825 10.876C3.57017 10.6267 3.06733 10.2883 2.63975 9.86088C2.21217 9.43346 1.87362 8.93083 1.62412 8.353C1.37471 7.77517 1.25 7.15779 1.25 6.50087C1.25 5.84387 1.37467 5.22633 1.624 4.64825C1.87333 4.07017 2.21171 3.56733 2.63913 3.13975C3.06654 2.71217 3.56917 2.37362 4.147 2.12412C4.72483 1.87471 5.34221 1.75 5.99913 1.75C6.65613 1.75 7.27367 1.87467 7.85175 2.124C8.42983 2.37333 8.93267 2.71171 9.36025 3.13913C9.78783 3.56654 10.1264 4.06917 10.3759 4.647C10.6253 5.22483 10.75 5.84221 10.75 6.49913C10.75 7.15613 10.6253 7.77367 10.376 8.35175C10.1267 8.92983 9.78829 9.43267 9.36088 9.86025C8.93346 10.2878 8.43083 10.6264 7.853 10.8759C7.27517 11.1253 6.65779 11.25 6.00087 11.25Z"
        fill="#FC645A"
      />
    </svg>
  );
};
